import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

// Registrar service worker para notificaciones
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Registrar el Service Worker principal (Workbox)
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ SW principal registrado:', registration);
        
        // Registrar el Service Worker de notificaciones
        return navigator.serviceWorker.register('/sw-notifications.js', {
          scope: '/'
        });
      })
      .then((notificationRegistration) => {
        console.log('✅ SW notificaciones registrado:', notificationRegistration);
        
        // Escuchar mensajes del Service Worker
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data.type === 'NAVIGATE_TO') {
            window.location.href = event.data.data.url;
          }
        });
      })
      .catch((registrationError) => {
        console.log('❌ SW falló:', registrationError);
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);